export function Tag({ children }: { children: string }) {
  return (
    <li className="rounded-sm border border-border bg-surface-2 px-2 py-1 font-mono text-[11px] leading-none text-muted">
      {children}
    </li>
  );
}

export function TagList({ items, label }: { items: readonly string[]; label: string }) {
  return (
    <ul aria-label={label} className="flex flex-wrap gap-1.5">
      {items.map((item) => (
        <Tag key={item}>{item}</Tag>
      ))}
    </ul>
  );
}
